<template>
    <div class="page-header">
        <v-btn v-if="back" icon class="mr-2" :to="back" exact>
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="page-heading">
            <h1 class="page-title">{{ title }}</h1>
            <div v-if="subtitle" class="page-subtitle">{{ subtitle }}</div>
        </div>
        <v-spacer />
        <div class="page-actions">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageHeader',
        props: {
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: null
            },
            back: {
                type: [String, Object],
                default: null
            }
        }
    }
</script>

<style scoped>
.page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
}

.page-heading {
    min-width: 0;
}

.page-title {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.3;
    color: var(--v-primary-base);
}

.page-subtitle {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
}

.page-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>
